<template>
  <v-row
    no-gutters
    align="center"
  >
    <v-col
      cols="12"
      md="4"
    >
      <v-select
        :value="role"
        :items="roleOptions"
        :loading="isLoadingRoles"
        item-text="text"
        item-value="value"
        label="ロール"
        placeholder="ロールを選択してください"
        hide-details
        no-data-text="選択可能なロールがありません"
        class="mr-md-4"
        @change="$emit('update:role', $event)"
      />
    </v-col>

    <v-col
      cols="12"
      md="4"
    >
      <v-menu
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template #activator="{ on, attrs }">
          <v-text-field
            :value="dateRangeText"
            :prepend-icon="icons.mdiCalendar"
            label="期間"
            readonly
            hide-details
            v-bind="attrs"
            class="mr-md-4"
            v-on="on"
          />
        </template>

        <v-date-picker
          :value="dates"
          locale="ja"
          :day-format="date => new Date(date).getDate()"
          color="primary"
          range
          no-title
          @input="$emit('update:dates', $event)"
        />
      </v-menu>
    </v-col>

    <v-col
      v-if="!hideBuildButton"
      cols="12"
      md="4"
      class="d-flex align-center mt-4 mt-md-0"
    >
      <v-btn
        color="primary"
        :disabled="!isValidSelection || isBuilding"
        :loading="isBuilding"
        @click="$emit('build')"
      >
        確定データを作成
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { computed } from '@vue/composition-api'
import { mdiCalendar } from '@mdi/js'

export default {
  props: {
    role: {
      type: String,
      default: null,
    },
    roleOptions: {
      type: Array,
      default: () => [],
    },
    isLoadingRoles: {
      type: Boolean,
      default: false,
    },
    dates: {
      type: Array,
      default: () => [],
    },
    isValidSelection: {
      type: Boolean,
      default: false,
    },
    isBuilding: {
      type: Boolean,
      default: false,
    },
    hideBuildButton: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const dateRangeText = computed(() => {
      const valid = props.dates.filter(d => !!d)
      if (valid.length < 2) return ''
      const sorted = [...valid].sort()

      return `${sorted[0]} ~ ${sorted[1]}`
    })

    return {
      dateRangeText,
      icons: {
        mdiCalendar,
      },
    }
  },
}
</script>
